import React, { useCallback } from 'react';
import { ListSortControl } from '@ui/ListSortControl';
import {
  useSortElementsBy,
  setSortElementsBy,
  useSortElementsDirection,
  setSortElementsDirection,
  SortElementsOptions,
} from '@client/hooks/use-filter-elements.hooks';
import amplitudeLog from '@client/amplitude';
import { SortByAlternativeKey } from '@shared/helpers/tree.helpers';
import { AMP_ELEMENT_LIST_SORT } from '@shared/constants/amplitude-events';
const SORT_OPTIONS: Partial<
  Record<SortByAlternativeKey<SortElementsOptions>, string>
> = {
  name: 'Name',
  co2: 'Carbon',
  cost: 'Expenses',
  position: 'Position',
};

export const ElementListSortControl: React.FC = () => {
  const sortBy = useSortElementsBy();
  const direction = useSortElementsDirection();

  const handleSortChange = useCallback(
    (option: SortByAlternativeKey<SortElementsOptions>) => {
      setSortElementsBy(option);
      amplitudeLog(AMP_ELEMENT_LIST_SORT, { Sort: option });
    },
    [],
  );

  return (
    <ListSortControl
      value={sortBy}
      options={SORT_OPTIONS}
      onChange={handleSortChange}
      direction={direction}
      onDirectionChange={setSortElementsDirection}
      preserveOptionOrder
    />
  );
};
